import styled from '@emotion/styled';
import { Link, withSpacingStyles } from '@vmos2/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  className: string,
  display: 'horizontal' | 'vertical',
};

export const SubscriptionLinks = withSpacingStyles(({ className, display = 'vertical' }: Props) => {
  const { t } = useTranslation('subscriptions');
  const links = t('links', { returnObjects: true });

  return (
    !!links.length && (
      <Links className={className} data-test="subscription-links" display={display}>
        {links.map(link => (
          <Link key={link.title} showExternalLinkIcon url={link.url}>{link.title}</Link>
        ))}
      </Links>
    )
  );
});

const Links = styled.div`
  display: inline-flex;

  ${({ display }) => display === 'vertical' && `
    align-items: flex-start;
    flex-direction: column;
  `}

  ${({ display }) => display === 'horizontal' && `
    flex-wrap: wrap;
  `}

  gap: ${({ theme }) => `${theme.margins.md} ${theme.margins.xl}`};
`;
